import React from 'react';
import { Search } from 'lucide-react';

interface SearchAndFiltersProps {
  searchInput: string;
  onSearchInputChange: (value: string) => void;
  perPage: number;
  onPerPageChange: (value: number) => void;
  total: number;
  loading: boolean;
  showNeedFollowUp?: boolean;
  onShowNeedFollowUpChange?: (value: boolean) => void;
  isActivelyUsing?: boolean;
  onIsActivelyUsingChange?: (value: boolean) => void;
  orderBy?: string;
  onOrderByChange?: (value: string) => void;
}

const SearchAndFilters: React.FC<SearchAndFiltersProps> = ({
  searchInput,
  onSearchInputChange,
  perPage,
  onPerPageChange,
  total,
  loading,
  showNeedFollowUp = false,
  onShowNeedFollowUpChange,
  isActivelyUsing = false,
  onIsActivelyUsingChange,
  orderBy = 'created-at',
  onOrderByChange
}) => {
  return (
    <div className="mb-6 bg-white p-4 rounded-lg shadow">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              placeholder="Search companies..."
              value={searchInput}
              onChange={(e) => onSearchInputChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <label className="text-sm font-medium text-gray-700">Per page:</label>
          <select
            value={perPage}
            onChange={(e) => onPerPageChange(Number(e.target.value))}
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="showNeedFollowUp"
            checked={showNeedFollowUp}
            onChange={(e) => onShowNeedFollowUpChange?.(e.target.checked)}
            className="h-4 w-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
          />
          <label htmlFor="showNeedFollowUp" className="text-sm font-medium text-gray-700 cursor-pointer">
            Show need follow up
          </label>
        </div>
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="isActivelyUsing"
            checked={isActivelyUsing}
            onChange={(e) => onIsActivelyUsingChange?.(e.target.checked)}
            className="h-4 w-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
          />
          <label htmlFor="isActivelyUsing" className="text-sm font-medium text-gray-700 cursor-pointer">
            Sedang aktif dipakai
          </label>
        </div>
        <div className="flex items-center gap-2">
          <label className="text-sm font-medium text-gray-700">Order by:</label>
          <select
            value={orderBy}
            onChange={(e) => onOrderByChange?.(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            <option value="created-at">Created At</option>
            <option value="sales-count">Sales Count</option>
          </select>
        </div>
      </div>
      
      {/* Results Summary */}
      {!loading && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-600">
            {searchInput ? `Found ${total.toLocaleString()} companies matching "${searchInput}"` : `Showing ${total.toLocaleString()} companies`}
          </p>
        </div>
      )}
    </div>
  );
};

export default SearchAndFilters;
